import { App, Component } from 'vue'

/* Registers every component under src/components globally, by its `name` */
const componentModules = import.meta.glob<{ default: Component & { name?: string } }>('./**/*.vue', {
  eager: true,
})

export default function registerGlobalComponents(app: App) {
  for (const module of Object.values(componentModules)) {
    const component = module.default
    if (component.name) {
      app.component(component.name, component)
    }
  }
}
